<template>
    <el-dialog class="el-dialogs" :title="title" width="800px" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent
                 label-width="110px">
            <div class="minTitle">基础信息设置</div>
            <div class="flex_b_c typesetting">
                <el-form-item label="数据源名称：" prop="interfaceName" class="itemInput">
                    <el-input v-model.trim="searchForm.interfaceName" maxlength="20"
                              placeholder="请输入数据源名称(限20字)"
                              clearable></el-input>
                </el-form-item>
                <el-form-item label="接口地址：" prop="interfaceAddress" class="itemInput">
                    <el-input v-model.trim="searchForm.interfaceAddress" maxlength="100"
                              placeholder="请输入接口地址(限100字)"
                              clearable></el-input>
                </el-form-item>
                <el-form-item label="用户名：" prop="userName" class="itemInput">
                    <el-input v-model.trim="searchForm.userName" maxlength="20"
                              placeholder="请输入用户名(限20字)"
                              clearable></el-input>
                </el-form-item>
                <el-form-item label="密码：" prop="userPassword" class="itemInput">
                    <el-input v-model.trim="searchForm.userPassword" maxlength="20"
                              placeholder="请输入密码(限20字)"
                              clearable></el-input>
                </el-form-item>
                <el-form-item label="请求类型：" prop="requestType" class="itemInput">
                    <el-select style="width: 100%" v-model="searchForm.requestType"
                               clearable
                               placeholder="请选择请求类型">
                        <el-option
                                v-for="item in $dictUtils.getDictList('request_type')"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="格式：" prop="interfaceFormat" class="itemInput">
                    <el-select style="width: 100%" v-model="searchForm.interfaceFormat"
                               clearable
                               placeholder="请选择格式">
                        <el-option
                                v-for="item in $dictUtils.getDictList('interface_format')"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="原始编码：" prop="oldEncod" class="itemInput">
                    <el-select style="width: 100%" v-model="searchForm.oldEncod"
                               clearable
                               placeholder="请选择编码">
                        <el-option
                                v-for="item in $dictUtils.getDictList('encod_type')"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="目标编码：" prop="targetEncoding" class="itemInput">
                    <el-select style="width: 100%" v-model="searchForm.targetEncoding"
                               clearable
                               placeholder="请选择编码">
                        <el-option
                                v-for="item in $dictUtils.getDictList('encod_type')"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <el-form-item label="描述：" prop="interfaceDescribe">
                <el-input
                        type="textarea"
                        placeholder="描述(限200字)"
                        v-model="searchForm.interfaceDescribe"
                        maxlength="200"
                        rows="5" resize="none"
                ></el-input>
            </el-form-item>
            <el-form-item label="执行周期：" prop="interfaceCron" class="itemInput">
                <div class="flex_b_c">
                    <el-input v-model.trim="searchForm.interfaceCron" maxlength="50"
                              placeholder="请输入执行周期(限50字)" style="margin-right: 10px"
                              clearable></el-input>
                    <el-popover
                            placement="top-start"
                            width="600"
                            trigger="hover">
                        <div style="white-space: pre-wrap;">
                            Cron表达式是一个由6个子表达式组成的字符串。每个子表达式都描述了一个单独的日程细节。
                            这些子表达式用空格分隔，分别表示：<br>
                            秒（0~59）<br>
                            分钟（0~59）<br>
                            小时（0~23）<br>
                            天（月）（1~31，取决于月份）<br>
                            月（1~12）<br>
                            天（星期）（可使用数字或英文缩写，如1或者MON,其中0和7都代表星期天（SUN））<br>
                            其中每个元素可以是一个值（如6）,一个连续区间（9-12）,一个间隔时间（8-18/4）
                            （表示8-18中每隔4（分钟、小时......取决于子表达式））,一个列表（1,3,5）,通配符。<br>
                            由于"月份中的日期"和"星期中的日期"这两个子表达式是互斥的,必须要对其中一个设置"?".<br>
                            cron表达式举例：<br>
                            0 0 10,14,16 * * ? 每天上午10点，下午2点，4点<br>
                            0 0/30 9-17 * * ? 朝九晚五工作时间内每半小时<br>
                            0 0 12 ? * WED 表示每个星期三中午12点<br>
                            0 0 12 * * ? 每天中午12点触发<br>
                            0 15 10 ? * * 每天上午10:15触发<br>
                            0 15 10 * * ? 每天上午10:15触发<br>
                            0 * 14 * * ? 在每天下午2点到下午2:59期间的每1分钟触发<br>
                            0 0/5 14 * * ? 在每天下午2点到下午2:55期间的每5分钟触发<br>
                        </div>
                        <div slot="reference" class="iconPrompt el-icon-question"></div>
                    </el-popover>
                </div>
            </el-form-item>
            <el-form-item label="同步数据值：" prop="synchronizationType" class="itemInput">
                <el-select style="width: 100%" v-model="searchForm.synchronizationType"
                           clearable
                           placeholder="同步数据值">
                    <el-option
                            v-for="item in synchronousList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <div class="minTitle">参数设置</div>
            <div class="btnSty">
                <el-button size="small" type="primary" @click="addParameter()">新增</el-button>
                <el-button size="small" type="primary" @click="deletaParameter()">删除</el-button>
            </div>
            <el-table
                    :data="dataList"
                    size="small" height="200px"
                    class="table" border
                    ref="multipleTable"
                    :row-key="'id'"
                    @selection-change="selectionChangeHandle"
            >
                <el-table-column :reserve-selection="true" type="selection" width="50"/>
                <el-table-column prop="parameterName" label="参数名称" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <el-input v-model.trim="row.parameterName" maxlength="20"
                                  placeholder="参数名称(限20字)" size="mini"
                                  clearable></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="parameterHead" label="头部参数" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <el-select style="width: 100%" size="mini" v-model="row.parameterHead"
                                   clearable
                                   placeholder="请选择头部参数">
                            <el-option label="是" value="0"></el-option>
                            <el-option label="否" value="1"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column prop="parameterDescribe" label="参数描述" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <el-input v-model.trim="row.parameterDescribe" maxlength="20"
                                  placeholder="参数描述(限20字)" size="mini"
                                  clearable></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="defaultValue" label="参数默认值" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <el-input v-model.trim="row.defaultValue" maxlength="20" style="width: 90%"
                                  placeholder="参数默认值(限20字)" size="mini"
                                  clearable></el-input>
                    </template>
                </el-table-column>
            </el-table>
        </el-form>
        <div slot="footer" class="text_right">
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>确定</el-button>
            <el-button size="small" @click="visible = false">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>

import {isValidCron} from "cron-validator";

export default {
    name: "interfaceAdd",
    data() {
        var verifyExpression = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入cron表达式'));
            } else {
                if (!isValidCron(value)) {
                    callback(new Error('请输入正确的cron表达式'));
                } else {
                    callback();
                }
            }
        };
        return {
            title: '新建接口数据源',
            visible: false,
            searchForm: {
                interfaceName: '',
                interfaceAddress: '',
                userName: '',
                userPassword: '',
                requestType: '',
                interfaceFormat: '',
                oldEncod: '',
                targetEncoding: '',
                interfaceDescribe: '',
                interfaceCron: '',
                synchronizationType: '',
                interfaceSourceParameters:[],
            },
            rules: {
                interfaceName: [
                    {required: true, message: '请输入数据源名称', trigger: 'blur'}
                ],
                interfaceAddress: [
                    {required: true, message: '请输入接口地址', trigger: 'blur'}
                ],
                interfaceCron: [
                    {validator: verifyExpression, trigger: 'blur'},
                    {required: true, message: '请输入cron表达式', trigger: 'blur'}
                ],
                synchronizationType: [
                    {required: true, message: '请选择同步数据值', trigger: 'change'}
                ],
            },
            synchronousList: [
                {
                    label: '全部同步',
                    value: 0,
                },
                {
                    label: '增量同步',
                    value: 1,
                },
            ],
            dataList: [],
            dataListSelect: [],
        }
    },

    methods: {
        //typeName see查看 edit编辑 add新增
        init(typeName, row) {
            this.visible = true
            this.dataList = []
            this.dataListSelect = []
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields();
            })
            if (typeName == 'add') {
                this.title = '新建接口数据源'
            }
            if (typeName == 'see') {
                this.title = '查看接口数据源'
                this.getDetail(row)
            }
        },

        getDetail(row){
            this.$axios(this.api.academic.interfacesourceGetById + row.id).then(data => {
                if (data && data.status) {
                    Object.keys(this.searchForm).forEach(key => {
                        this.searchForm[key] = data.data[key]
                    })
                    this.dataList = this.searchForm.interfaceSourceParameters
                }
            })
        },

        //表格勾选数据
        selectionChangeHandle(val,data) {
            console.log(val,data)
            this.dataListSelect = val
        },

        //添加参数
        addParameter() {
            let id = new Date().getTime()
            this.dataList.push({
                id,
                parameterName: '',
                parameterHead: '',
                parameterDescribe: '',
                defaultValue: '',
            })
        },

        //删除参数
        deletaParameter() {
            if (this.dataListSelect.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            this.$confirm(`确认删除所选参数？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.dataListSelect.forEach(item => {
                    this.dataList = this.dataList.filter(item2 => {
                        return item2.id != item.id
                    })
                })
                this.$nextTick(()=>{
                    this.$refs.multipleTable.clearSelection()
                })
            })
        },

        //提交
        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    this.searchForm.interfaceSourceParameters = this.dataList
                    if (this.searchForm.id) {
                        this.$axios(this.api.academic.interfacesourceUpdateById, this.searchForm, 'put').then(data => {
                            if (data && data.status) {
                                this.$message.success('修改成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        this.$axios(this.api.academic.interfacesourceSave, this.searchForm, 'post').then(data => {
                            if (data && data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },
    },
}
</script>

<style scoped>
/*.el-dialogs >>> .el-dialog__body {*/
/*    height: auto !important;*/
/*}*/

.minTitle {
    margin-top: 10px 0 5px;
    font-size: 14px;
    font-weight: bold;
}

.iconPrompt {
    font-size: 22px;
    width: 22px;
    height: 22px;
}

.typesetting {
    flex-wrap: wrap;
}

.itemInput {
    width: 49.5%;
}

.btnSty {
    margin: 10px 0;
}
</style>